import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule} from '@angular/common/http';
import { EmpresaService} from './service/empresa/empresa.service';
import { AccesoService} from './service/acceso/acceso.service';
import { DocumentoService} from './service/documento/documento.service';
// ANGULAR MATERIAL COMPONENTS
import { MatCheckboxModule, MatDividerModule, MatRippleModule } from '@angular/material';

import { MatButtonModule } from '@angular/material';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTreeModule } from '@angular/material/tree';
import { SorteoComponent } from './sorteo/sorteo.component';
import { PromoComponent } from './promo/promo.component';
import { FinPromoComponent } from './fin-promo/fin-promo.component';
import { ValidateUserComponent } from './validate-user/validate-user.component';
import { ThanksComponent } from './thanks/thanks.component';
import { FooterComponent } from './layout/footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import {MatAnimatedIconComponent } from './lib/mat-animated-icon/mat-animated-icon.component'
// libreria para cerrar la session luego de un tiempo determinado
import { UserIdleModule } from 'angular-user-idle';

// SessionExpirationAlert
import { SessionExpirationAlert, SessionInteruptService } from 'session-expiration-alert';
import { AppSessionInteruptService } from './service/session.service';

import { BnNgIdleService } from 'bn-ng-idle';



import { NgxMaskModule } from 'ngx-mask';
import { RecuperarPasswordComponent } from './recuperar-password/recuperar-password.component';
import { EvaluaFacturaRespuestaComponent } from './evalua-factura-respuesta/evalua-factura-respuesta.component';
import { EvaluaFacturaComponent } from './evaluaFactura/evaluaFactura.component';
import { RespuestaPrecalificaComponent } from './evalua-factura-respuesta/respuesta-precalifica/respuesta-precalifica.component';
import { RespuestaNoPrecalificaComponent } from './evalua-factura-respuesta/respuesta-no-precalifica/respuesta-no-precalifica.component';
import { ResumenFinalComponent } from './evalua-factura-respuesta/resumen-final/resumen-final.component';
import { SolicitudesComponent } from './libro-reclamaciones/solicitudes/solicitudes.component';
import { ConsultaEstadoComponent } from './libro-reclamaciones/consulta-estado/consulta-estado.component';
import { AyudaComponent } from './ayuda/ayuda.component';
import { RouterModule } from '@angular/router';



// import { CotizacionesComponent } from './cotizaciones/cotizaciones.component';
// import { ContratosComponent } from './contratos/contratos.component';
// import { PerfilComponent } from './perfil/perfil.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
    LoginComponent,
    SorteoComponent,
    PromoComponent,
    FinPromoComponent,
    ValidateUserComponent,
    ThanksComponent,
    FooterComponent,
    MatAnimatedIconComponent,
    RecuperarPasswordComponent,
    EvaluaFacturaRespuestaComponent,
    EvaluaFacturaComponent,
    RespuestaPrecalificaComponent,
    RespuestaNoPrecalificaComponent,
    ResumenFinalComponent,
    ///CambiarFotoComponent,
    SolicitudesComponent,
    ConsultaEstadoComponent,
    AyudaComponent,
    // CotizacionesComponent,
    // ContratosComponent,
    // PerfilComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
     // Angular Material Components
     MatCheckboxModule,
     MatCheckboxModule,
     MatButtonModule,
     MatAutocompleteModule,
     MatDividerModule,
     MatInputModule,
     MatAutocompleteModule,
     MatDatepickerModule,
     MatNativeDateModule,
     RouterModule,
     MatRadioModule,
     MatSelectModule,
     MatSliderModule,
     MatSlideToggleModule,
     MatMenuModule,
     MatSidenavModule,
     MatToolbarModule,
     MatListModule,
     MatGridListModule,
     MatCardModule,
     MatStepperModule,
     MatTabsModule,
     MatExpansionModule,
     MatButtonToggleModule,
     MatChipsModule,
     MatIconModule,
     MatProgressSpinnerModule,
     MatProgressBarModule,
     MatDialogModule,
     MatTooltipModule,
     MatSnackBarModule,
     MatTableModule,
     MatSortModule,
     MatPaginatorModule,
     MatTreeModule,
     MatRippleModule,
     MatMenuModule,
     MatCardModule,
     MatGridListModule,
     MatSnackBarModule,


     // Reactive Forms DFUI
     FormsModule,
    ReactiveFormsModule,
    UserIdleModule.forRoot({idle: 3, timeout: 5, ping: 3}),
    SessionExpirationAlert.forRoot({totalMinutes: 0.5}),

    // TextMaskModule,
    NgxMaskModule.forRoot(),

  ],
  exports:[
 SharedModule,
  ],
  providers: [BnNgIdleService,{
    provide: SessionInteruptService,
    useClass: AppSessionInteruptService
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
